import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) {
  }

  transform(value: string, arg: string): string {
    if (!arg || !value) return value;
    let regex = new RegExp(arg, 'gi');
    return String(value).replace(regex, '<strong class=\'highlight\'>$&</strong>');
  }
}
